import { render, staticRenderFns } from "./TurnaroundLocationField.vue?vue&type=template&id=35cdbfc4"
import script from "./TurnaroundLocationField.vue?vue&type=script&lang=js"
export * from "./TurnaroundLocationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports